import { deferredResourceQueryOptions } from "@/utils/deferred-resource-query";
import { orpc } from "@/utils/orpc.client";

interface ReleaseNotesResourceQueryOptionsInput {
  releaseId: string;
  locale: string;
}

export function getReleaseNotesResourceQueryOptions({
  releaseId,
  locale,
}: ReleaseNotesResourceQueryOptionsInput) {
  return deferredResourceQueryOptions(
    orpc.music.getReleaseNotesResource.queryOptions({
      input: { releaseId, locale },
    }),
  );
}
